<template>
  <RouterLink :to="{name: 'composerById', params: { locale: $i18n.localePath(), id: composer.id }}"
              :title="displayComposerName(composer)"
  >
    {{ displayComposerName(composer) }}
  </RouterLink>
</template>
<script>
import { displayComposerName } from '@/assets/helpers/TrackHelper'
export default {
  name: 'PlaylistTableComposer',
  components: {},
  directives: {},
  props: {
    composer: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    displayComposerName
  }
}
</script>
